import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import validate from 'validate.js';
import { Grid } from '@mui/material';
import moment from 'moment';
import {
  DialogDefaultV2,
  UsuarioDocumentoSelectV2,
  DatePickerV2,
  ArquivoContainerV2,
} from '../../../components/v2';
import * as actionsUsuarioDocumentos from '../../../store/usuarioDocumento/actions';
import * as selectors from '../../../store/usuarioDocumento/reducer';

const schema = {
  id: { presence: { allowEmpty: false, message: 'é obrigatório' } },
  dataDocumento: { presence: { allowEmpty: false, message: 'é obrigatório' } },
};

const schemaValidoAte = {
  id: { presence: { allowEmpty: false, message: 'é obrigatório' } },
  dataDocumento: { presence: { allowEmpty: false, message: 'é obrigatório' } },
  validoAte: { presence: { allowEmpty: false, message: 'é obrigatório' } },
};

const DocumentoForm = ({
  open,
  usuarioDocumento,
  onClose,
  isCertificado,
  onSave,
  documentoUsuarios,
  documentoUsuarioIds,
  readOnly,
}) => {
  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({});
  const [selectedDocument, setSelectedDocument] = useState({});
  const [disabledValidoAte, setDisabledValidoAte] = useState(true);
  const [documentoIdsFilter, setDocumentoIdsFilter] = useState([]);

  useEffect(() => {
    if (usuarioDocumento) {
      setValues(usuarioDocumento);
      setDocumentoIdsFilter(documentoUsuarioIds.filter((d) => d !== usuarioDocumento.id));
      const documento = documentoUsuarios.find((d) => d.id === usuarioDocumento.id);
      setDisabledValidoAte(!(documento && documento.possuiValidade));
    } else {
      setValues({});
      setDocumentoIdsFilter(documentoUsuarioIds);
    }
  }, [usuarioDocumento, documentoUsuarioIds]);

  const onSaveLocal = () => {
    const activeSchema = disabledValidoAte ? schema : schemaValidoAte;
    const erros = validate(values, activeSchema);
    setErrors(erros);
    if (!erros) {
      onSave({ ...values, nome: selectedDocument.nome || values.nome, tipo: isCertificado ? 'CERTIFICADO' : 'DOCUMENTO' });
      onCloseLocal();
    }
  };

  const onCloseLocal = () => {
    setErrors({});
    setValues({});
    setSelectedDocument({});
    setDisabledValidoAte(true);
    setDocumentoIdsFilter([]);
    onClose();
  };

  const handleChangeDocument = (documentoId) => {
    const documento = documentoUsuarios.find((d) => d.id === documentoId);
    let validoAte = null;
    if (documento && documento.possuiValidade && values.dataDocumento) {
      validoAte = moment(values.dataDocumento).add(documento.validadeEmAnos, 'years').valueOf();
    }
    setValues({ ...values, id: documentoId, validoAte });
    setSelectedDocument(documento);
    setDisabledValidoAte(!(documento && documento.possuiValidade));
  };

  const handleChangeDataDocumento = (data) => {
    let validoAte = null;
    if (!String(data).includes('/') && selectedDocument && selectedDocument.possuiValidade) {
      validoAte = moment(data).add(selectedDocument.validadeEmAnos, 'years').valueOf();
    }
    setValues({ ...values, dataDocumento: data, validoAte });
  };

  return (
    <DialogDefaultV2
      open={open}
      handlerCancel={onCloseLocal}
      handlerConfirm={onSaveLocal}
      title={isCertificado ? 'Certificado' : 'Documento'}
      confirmMessage="Vincular"
      maxWidth="md"
      readOnly={readOnly}
    >
      <Grid container spacing={3}>
        <Grid size={{ md: 12 }}>
          <UsuarioDocumentoSelectV2
            label={isCertificado ? 'Certificado' : 'Documento'}
            tipoDocumento={isCertificado ? 'CERTIFICADO' : 'DOCUMENTO'}
            name="id"
            isRequired
            onSelect={handleChangeDocument}
            value={values.id}
            error={errors && errors.id}
            filterIds={documentoIdsFilter}
            disabled={readOnly}
          />
        </Grid>
        <Grid size={{ xs: 4 }}>
          <DatePickerV2
            label={`Data ${isCertificado ? 'Certificado' : 'Documento'}`}
            onChange={handleChangeDataDocumento}
            value={values.dataDocumento}
            isRequired
            error={errors && errors.dataDocumento}
            disabled={readOnly}
            showInput
          />
        </Grid>
        <Grid size={{ xs: 4 }}>
          <DatePickerV2
            label="Válido até"
            onChange={(data) => setValues({ ...values, validoAte: data })}
            value={values.validoAte}
            isRequired={!disabledValidoAte}
            error={errors && errors.validoAte && !disabledValidoAte}
            disabled={readOnly || disabledValidoAte}
            showInput
          />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <ArquivoContainerV2
            arquivos={values.arquivos}
            onSave={(arquivos) => setValues({ ...values, arquivos })}
            disabled={readOnly}
          />
        </Grid>
      </Grid>
    </DialogDefaultV2>
  );
};

const mapStateToProps = (state) => ({
  documentoUsuarios: selectors.getUsuarioDocumentosOptions(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({ ...actionsUsuarioDocumentos }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DocumentoForm));
